import { Statuses } from '@/V2/components/status/utils';
import { CustomerInsightResult } from '@/utils/customerInsights';

export const CUSTOMER_SIGNAL = {
  MULTIPLE_HIGH_RISK_DOCUMENTS: 'multiple_high_risk_documents',
  MULTIPLE_DOCUMENT_RISK_SIGNALS: 'multiple_document_risk_signals',
  UNUSUAL_TRANSACTION_PATTERNS: 'unusual_transaction_patterns',
  PREVIOUS_HIGH_RISK_APPLICATIONS: 'previous_high_risk_applications',
  SALARY_CROSS_CHECK: 'SALARY_CROSS_CHECK',
  COMPANY_EXISTENCE: 'COMPANY_EXISTENCE',
  CONNECTION_BETWEEN_PERSON_AND_ADDRESS:
    'CONNECTION_BETWEEN_PERSON_AND_ADDRESS',
  CONNECTION_BETWEEN_PERSON_AND_COMPANY:
    'CONNECTION_BETWEEN_PERSON_AND_COMPANY',
  PERSON_ADDRESS_EXISTENCE: 'PERSON_ADDRESS_EXISTENCE',
  COMPANY_ADDRESS_EXISTENCE: 'COMPANY_ADDRESS_EXISTENCE',
  COMPANY_WEB_PRESENCE: 'COMPANY_WEB_PRESENCE',
  CONNECTION_BETWEEN_COMPANY_AND_ADDRESS:
    'CONNECTION_BETWEEN_COMPANY_AND_ADDRESS',
};

export const CUSTOMER_SIGNAL_CONFIG = {
  [CUSTOMER_SIGNAL.PREVIOUS_HIGH_RISK_APPLICATIONS]: {
    label: 'Previous Fraudulent Applications',
    description:
      'Customer has submitted previous applications that were deemed fraudulent',
    sortOrder: 1,
  },
  [CUSTOMER_SIGNAL.UNUSUAL_TRANSACTION_PATTERNS]: {
    label: 'Suspicious Transaction Patterns',
    description: 'Unusual patterns detected in document transactions',
    sortOrder: 3,
  },
  [CUSTOMER_SIGNAL.MULTIPLE_HIGH_RISK_DOCUMENTS]: {
    label: 'High-Risk Documents Detected',
    description: 'Customer contains high-risk documents',
    sortOrder: 5,
    highRisk: true,
  },
  [CUSTOMER_SIGNAL.MULTIPLE_DOCUMENT_RISK_SIGNALS]: {
    label: 'High-Severity Signals Detected',
    description: 'Customer documents include high-severity fraud signals',
    sortOrder: 6,
    highRisk: true,
  },
  [CUSTOMER_SIGNAL.COMPANY_EXISTENCE]: {
    label: 'Company Verification',
    description: '',
    isVerification: true,
    sortOrder: 7,
  },
  [CUSTOMER_SIGNAL.PERSON_ADDRESS_EXISTENCE]: {
    label: 'Proof of Address',
    description: '',
    isVerification: true,
    sortOrder: 8,
  },
  [CUSTOMER_SIGNAL.CONNECTION_BETWEEN_PERSON_AND_COMPANY]: {
    label: 'Connection Between Person and Company',
    description: '',
    isVerification: true,
    sortOrder: 9,
  },
  [CUSTOMER_SIGNAL.CONNECTION_BETWEEN_PERSON_AND_ADDRESS]: {
    label: 'Person Address Verification',
    description: '',
    isVerification: true,
    sortOrder: 10,
  },
  [CUSTOMER_SIGNAL.COMPANY_ADDRESS_EXISTENCE]: {
    label: 'Company Address Verification',
    description: '',
    isVerification: true,
    sortOrder: 11,
  },
  [CUSTOMER_SIGNAL.CONNECTION_BETWEEN_COMPANY_AND_ADDRESS]: {
    label: 'Connection Between Company and Address',
    description: '',
    isVerification: true,
    sortOrder: 12,
  },
  [CUSTOMER_SIGNAL.COMPANY_WEB_PRESENCE]: {
    label: 'Company Web Presence',
    description: '',
    isVerification: true,
    sortOrder: 13,
  },
  [CUSTOMER_SIGNAL.SALARY_CROSS_CHECK]: {
    label: 'Salary Cross-Check',
    description: '',
    sortOrder: 14,
  },
};

export const SalaryCrossCheckOutcome = {
  UNMATCHED: 'UNMATCHED',
  PARTIALLY_MATCHED: 'PARTIALLY_MATCHED',
  MATCHED: 'MATCHED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};

export const UNIFIED_AGENT_RESULT_TO_OUTCOME_MAP = {
  [CustomerInsightResult.NOT_APPLICABLE]:
    SalaryCrossCheckOutcome.NOT_APPLICABLE,
  [CustomerInsightResult.LOW]: SalaryCrossCheckOutcome.MATCHED,
  [CustomerInsightResult.MEDIUM]: SalaryCrossCheckOutcome.PARTIALLY_MATCHED,
  [CustomerInsightResult.HIGH]: SalaryCrossCheckOutcome.UNMATCHED,
};

export const SALARY_CROSS_CHECK_PROPERTIES = {
  [SalaryCrossCheckOutcome.UNMATCHED]: {
    label: 'Unmatched',
    status: Statuses.ERROR,
    icon: 'small-solid-alert-triangle',
  },
  [SalaryCrossCheckOutcome.PARTIALLY_MATCHED]: {
    label: 'Partially matched',
    status: Statuses.WARNING,
    icon: 'small-solid-alert-circle',
  },
  [SalaryCrossCheckOutcome.MATCHED]: {
    label: 'Matched',
    status: Statuses.SUCCESS,
    icon: 'small-solid-check',
  },
  [SalaryCrossCheckOutcome.NOT_APPLICABLE]: {
    label: 'Not applicable',
    status: Statuses.NOT_APPLICABLE,
    icon: 'small-solid-info-circle',
  },
};
